export const STORE_IOTA_AUDIT = 'IotaAuditUI';
export type STORE_IOTA_AUDIT = typeof STORE_IOTA_AUDIT;
